export enum ListState {
    Closed,
    Open
}
